import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { SchemeQuery as SchemeQueryType, SchemeQueryVariables } from "./__generated__/SchemeQuery";

const SchemeQuery = loader("./SchemeQuery.gql");

type SchemeQueryProviderType = (props: {
  children: (data: SchemeQueryType) => ReactNode;
  variables: SchemeQueryVariables;
}) => ReactElement;

export const SchemeQueryProvider: SchemeQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<SchemeQueryType, SchemeQueryVariables>(SchemeQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
